// React
import React from 'react'
// Components
import Icon from '../Display/Icon'
import LifePurposeApp from '../Footer/LifePurposeApp'
import Social from '../Display/Social'
// Data
import { signs } from '../../data/signs'
// Components
import Button from '../Display/Button'
import Logo from '../Display/Logo'
// Components: Zodiac
import Aries from './Aries'
import Taurus from './Taurus'
import Gemini from './Gemini'
import Cancer from './Cancer'
import Leo from './Leo'
import Virgo from './Virgo'
import Libra from './Libra'
import Scorpio from './Scorpio'
import Sagittarius from './Sagittarius'
import Capricorn from './Capricorn'
import Aquarius from './Aquarius'
import Pisces from './Pisces'

export default class All extends React.Component {

	componentDidMount() {
		this.zodiacDescription.scrollTop = 0
		document.addEventListener('keydown', this.escFunction, false)
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.escFunction, false)
	}

	escFunction = (event) => {
		// Escape key
		if(event.keyCode === 27) {
			this.removePage()
		}
	}

	removePage = () => {
		if (this.props.state.nav.length > 1) {
			this.props.redux.nav.removePage()
		}
		else {
			this.props.redux.nav.setPage('')
		}
	}

	getZodiacDescription = (zodiac) => {
		switch (zodiac) {
			case 'aries':				return <Aries />
			case 'taurus':			return <Taurus />
			case 'gemini':			return <Gemini />
			case 'cancer':			return <Cancer />
			case 'leo':					return <Leo />
			case 'virgo':				return <Virgo />
			case 'libra':				return <Libra />
			case 'scorpio':			return <Scorpio />
			case 'sagittarius':	return <Sagittarius />
			case 'capricorn':		return <Capricorn />
			case 'aquarius':		return <Aquarius />
			case 'pisces':			return <Pisces />
			default:						return null
		}
	}

	render() {
		const { name, degree, minute } = this.props
		const { title, description } = signs.filter((sign) => (sign.sign === name))[0]
		return (
			<div className='capps-fullscreen' ref={div => { this.zodiacDescription = div }}>
				<div className='capps-close' onTouchTap={() => this.removePage()}>
					<span style={{ marginRight: '5px', marginBottom: '5px' }}>close</span> <Icon name='close-circle' color='dark' />
				</div>
				<Logo {...this.props} />
				<div className='capps-height-20' />
				<div className='capps-container'>
					<div className='capps-header'>{title}</div>
					<center>{(degree && minute) && <div className='capps-text bold'>at {degree}’ {minute}”</div>}</center>
					<div className='capps-height-20' />
					{(degree < 5 || degree > 25) && <center><span style={{ color: '#FF0000', fontWeight: '400' }}>In case you didn’t enter your time of birth: you may need to enter your time of birth because your moon sign is close to its {degree < 5 ? <span>previous</span> : <span>following</span>} sign</span><div className='capps-height-20' /></center>}

					{this.getZodiacDescription(name)}

					<div className='capps-responsive'>
						<div className='capps-height-20' />
						<div className='capps-height-20' />
						{/* NOTICE */}
						<div className='capps-form'>
							<div className='capps-header'>A note about your moon sign</div>
							<div className='capps-height-10' />
							The <span className='capps-link' onTouchTap={() => this.props.redux.nav.setPage('')}>Moon Sign App</span> is designed to give you an introductory glance into the wonderful world of lunar astrology. Your moon sign is but a small part of your overall astrological makeup &mdash; it’s by no means a comprehensive indicator of your personality &mdash; so please keep that in mind. If you wish to explore your astrological profile at a deeper level, we recommend you obtain an astrological reading from a trained, professional astrologer.
						</div>
						{/* IN-APP PURCHASE */}
						{this.props.user && !this.props.user.accountPaid &&
							<div>
								<div className='capps-height-20' />
								<Button
									action={() => this.props.redux.nav.setPage('upgrade')}
									text='Get Complete Access'
								/>
							</div>
						}
						{/* LIFE PURPOSE APP */}
						<LifePurposeApp {...this.props} />
					</div>
				</div>
				<div className='capps-height-20' />
				<div className='capps-footer'>© Copyright 2018 {new Date().getFullYear() > 2018 && '-' + new Date().getFullYear()} Conscious Apps Inc. All rights reserved.</div>
				<div className='capps-height-20' />
				<div className='capps-height-20' />
				<Social title={title} description={description} image={'zodiac-' + name + '.png'} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Zodiac/All.js